import { AxiosPromise } from "axios";

import api from "../config/api-config";

export function getManagers(): AxiosPromise {
  return api.get("v1/managers", {});
}

export function postManagers(obj: any): AxiosPromise {
  return api.post("v1/managers", obj, {});
}

export function putManagers(obj: any, id: any): AxiosPromise {
  return api.put("v1/managers/" + id, obj, {});
}

export function deleteManagers(id: number): AxiosPromise {
  return api.delete("v1/managers/" + id);
}

export function getManagerSettings(): AxiosPromise {
  return api.get("v1/managers/settings", {});
}

export default {
  getManagers,
  postManagers,
  putManagers,
  deleteManagers,
  getManagerSettings,
};
